<mui-alert *ngIf="showGPCHint" class="global-privacy-control-hint" icon="info-circle" [dismissible]="false">
  <p [innerHTML]="'globalPrivacyControl.message.subsidiary.us' | translate" class="mui-copytext"></p>
</mui-alert>
